import { render, staticRenderFns } from "./AttacksOfGreaterRepercussion.vue?vue&type=template&id=8c92236e&scoped=true"
import script from "./AttacksOfGreaterRepercussion.vue?vue&type=script&lang=ts"
export * from "./AttacksOfGreaterRepercussion.vue?vue&type=script&lang=ts"
import style0 from "./AttacksOfGreaterRepercussion.vue?vue&type=style&index=0&id=8c92236e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c92236e",
  null
  
)

export default component.exports